
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { share, download } from "@/utils";
import { dispatch, Task, Group } from "@/store";

export default Vue.extend({
  data() {
    return {
      task: { vote_conf: { enable: false } } as Task,
      groupIds: [] as number[],
      isFormTasks: false,
      timeoutTimer: 0,
      intervalTimer: 0,
      containerHeight: 0
    };
  },
  computed: {
    ...mapGetters({ allow: "allow" }),
    ...mapGetters({ coinName: "coinName" }),
    ...mapState({ user: "user" }),
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      images: "images",
      url: "url"
    }),
    ...mapState("tasks", {
      categoryList: "categoryList"
    }),
    id(): number {
      return Number(this.$route.params.id);
    },
    isAdd(): boolean {
      return !this.id;
    },
    group(): Group[] {
      const group = this.user.groupList.filter((group: Group) =>
        this.groupIds.includes(group.id)
      );
      return group;
    }
  },
  methods: {
    getTask() {
      dispatch
        .tasksGet(this.id)
        .then((task: Task) => {
          this.task = task;
          dispatch
            .tasksGetGroupIds((task.tags || []).map(i => i.tag_id || 0))
            .then(res => {
              this.groupIds = res.group_ids;
            });
          this.getSignFiles();
          share({
            title: task.title,
            desc: task.content
              ? task.content.replace(/(<([^>]+)>)/gi, "")
              : "Future Art Community",
            link: window.location.href,
            imgUrl:
              task.medias && task.medias.length
                ? task.medias[0].url
                : this.url.logo
          });
        })
        .catch(() => {
          if (!this.user.isSignIn) {
            this.$message.destroy();
            dispatch.userSignIn();
          }
        });
    },
    setListener() {
      document.querySelectorAll(".ql-editor .mention").forEach(mention => {
        const listener = (e: any) => {
          const id = e.currentTarget.getAttribute("data-id");
          const value = e.currentTarget.getAttribute("data-value");
          if (id && value?.includes("@"))
            window.open(this.$paths.users + id, "_blank");
          if (id && value?.includes("#"))
            window.open(this.$paths.dao + "?tag_ids=" + id, "_blank");
        };
        mention.removeEventListener("click", listener);
        mention.removeEventListener("contextmenu", listener);
        mention.addEventListener("click", listener);
        mention.addEventListener("contextmenu", listener);
      });
      document.querySelectorAll(".ql-editor .a").forEach(a => {
        const listener = (e: any) => {
          e.preventDefault();
          const { className, href, download: fileName } = e.currentTarget;
          if (className === "file" || fileName) {
            dispatch
              .filesGet([href], this.id)
              .then(res => {
                download(res[0]?.sign_url || href, fileName);
              })
              .catch(() => {
                download(href, fileName);
              });
          } else {
            window.open(href, "_blank");
          }
        };
        a.removeEventListener("click", listener);
        a.removeEventListener("contextmenu", listener);
        a.addEventListener("click", listener);
        a.addEventListener("contextmenu", listener);
      });

      // if (window.location.hash.includes("task-comment-")) {
      //   document.querySelectorAll(".ql-editor img").forEach(img => {
      //     const listener = () => {
      //       const comment = document.querySelector(window.location.hash);
      //       if (comment) {
      //         const offset =
      //           comment.getBoundingClientRect().top + window.pageYOffset - 50;
      //         window.scrollTo({
      //           top: offset,
      //           behavior: "smooth"
      //         });
      //       }
      //     };
      //     img.addEventListener("load", listener);
      //   });
      // }
    },
    getSignFiles() {
      const aliyunList =
        this.task.content.match(/https?:\/\/((?!").)+?aliyuncs.+?"/g) || [];
      const fileList = aliyunList.map((url: string) => url.replace('"', ""));
      if (fileList.length) {
        dispatch.filesGet(fileList, this.id).then(res => {
          fileList.map(url => {
            res.find((item: any) => {
              if (url.includes(item.request_url)) {
                this.task.content = this.task.content.replace(
                  url,
                  item.sign_url
                );
                return true;
              }
            });
          });
        });
      }
    },
    onVote(ids: number[]) {
      dispatch
        .tasksVote({ id: this.id, ids })
        .then(() => {
          this.$message.info("" + this.$t("task.voteSuccess"));
          this.getTask();
        })
        .catch(() => {
          if (!this.user.isSignIn) {
            this.$message.destroy();
            dispatch.userSignIn();
          }
        });
    },
    onDone() {
      const canReward =
        this.allow("task", "reward") && this.task.max_reward_number;
      const { enable, is_multi, max_num } = this.task.vote_conf;
      this.$confirm({
        title: this.$t(
          canReward ? "task.closeRewardConfirm" : "task.closeConfirm"
        ),
        centered: true,
        okText: "" + this.$t("task.ok"),
        cancelText: "" + this.$t("task.cancel"),
        onOk: () => {
          dispatch
            .tasksPatch({
              ...this.task,
              vote_conf: {
                enable: enable || false,
                is_multi: is_multi || false,
                max_num: max_num || "1"
              },
              status: "closed"
            })
            .then(() => {
              this.getTask();
              this.$message.info("" + this.$t("task.closeSuccess"));
              if (canReward) {
                dispatch.tasksReward(this.task).then(() => {
                  this.$message.info("" + this.$t("task.rewardSuccess"));
                });
              }
            });
        }
      });
    },
    onBack() {
      this.$router.push(this.$paths.dao);
      // this.isFormTasks
      //   ? this.$router.back()
      //   : this.$router.push(this.$paths.dao);
    },
    onChangeUser() {
      this.$confirm({
        title: this.$t("task.changeUserConfirm"),
        centered: true,
        okText: "" + this.$t("task.ok"),
        cancelText: "" + this.$t("task.cancel"),
        onOk: () => {
          dispatch.tasksChangeUser(this.task.id || 0).then(() => {
            this.getTask();
            this.$message.info("" + this.$t("task.changeUserSuccess"));
          });
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      vm.isFormTasks = from.path === vm.$paths.dao;
    });
  },
  mounted() {
    if (this.id) {
      this.getTask();
      this.timeoutTimer = setTimeout(() => {
        this.getSignFiles();
      }, 1000 * 60 * 20);
    } else {
      this.$router.push(this.$paths.dao);
    }
    this.intervalTimer = setInterval(() => {
      const container = document.querySelector(".task-detail > .container");
      if (container && this.containerHeight !== container.scrollHeight) {
        setTimeout(this.setListener, 1000);
        this.containerHeight = container.scrollHeight;
      }
    }, 1000);
  },
  beforeDestroy() {
    share({
      title: "Angry Miao",
      desc: "Future Art Community",
      link: window.location.href,
      imgUrl: this.url.logo
    });
    clearTimeout(this.timeoutTimer);
    clearInterval(this.intervalTimer);
  }
});
